<!-- TEMPLATE -->
<template>
  <gmap-map
    :center="center"
    :zoom="3"
    :options="mapStyle"
    style="width: 100%; height: 400px"
  >
    <gmap-info-window
      :options="infoOptions"
      :position="infoPosition"
      :opened="infoOpened"
      @closeclick="infoOpened = false"
    >
      {{ infoContent }}
    </gmap-info-window>

    <gmap-marker
      :key="index"
      v-for="(m, index) in markers"
      :position="m.position"
      @click="toggleInfo(m, key)"
      :icon="{ url: require('../assets/img/marker_clients.png') }"
    ></gmap-marker>
  </gmap-map>
</template>

<!-- SCRIPT -->
<script>
export default {
  name: "GoogleMaps",
  props: {
    data: "",
    icon: {
      default: "../assets/img/marker_clients.png",
    },
  },

  data() {
    return {
      center: { lat: 45.508, lng: -73.587 },
      markers_temp: [],
      markers: [],
      places: [],
      currentPlace: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      infoOpened: false,
      infoPosition: null,
      infoContent: null,
      mapStyle: {
        // other properties...
        styles: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#1d2c4d",
              },
            ],
          },
          {
            elementType: "geometry.fill",
            stylers: [
              {
                visibility: "on",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#8ec3b9",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1a3646",
              },
            ],
          },
          {
            featureType: "administrative.country",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#4b6878",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#64779e",
              },
            ],
          },
          {
            featureType: "administrative.province",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#4b6878",
              },
            ],
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#334e87",
              },
            ],
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [
              {
                color: "#023e58",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#283d6a",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#6f9ba5",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1d2c4d",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#023e58",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#3C7680",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#304a7d",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#98a5be",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1d2c4d",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#2c6675",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#255763",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#b0d5ce",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#023e58",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#98a5be",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1d2c4d",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#283d6a",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#3a4762",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#0e1626",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#4e6d70",
              },
            ],
          },
        ],
      },
    };
  },

  mounted() {
    this.geolocate();
    this.draw(this.data);
  },

  watch: {
    data: function (newData) {
      this.draw(newData);
    },
  },

  methods: {
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place;
    },

    draw(data) {
      this.markers_temp = [];
      this.places = [];

      if (Array.isArray(data)) {
        data.forEach((element) => {
          try {
            let lat = parseFloat(
              JSON.parse(element["geolocation"])["latitude"]
            );
            let lng = parseFloat(
              JSON.parse(element["geolocation"])["longitude"]
            );
            let txt = JSON.parse(element["geolocation"]);
            this.addMarker(lat, lng, txt);
          } catch (error) {}
        });
      } else {
        let element = data;
        try {
          let lat = parseFloat(element["latitude"]);
          let lng = parseFloat(element["longitude"]);
          let txt = element;
          this.addMarker(lat, lng, txt);
        } catch (error) {}
      }

      this.markers = this.markers_temp;
    },

    addMarker(lat, lng, txt) {
      const marker = {
        lat: lat,
        lng: lng,
        txt: txt,
      };
      this.markers_temp.push({ position: marker });
      this.places.push(this.currentPlace);
      this.center = marker;
      this.currentPlace = null;
    },

    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    toggleInfo: function (marker, key) {
      this.infoPosition = marker.position;
      this.infoContent = marker.position.txt;
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }
    },
  },
};
</script>


<!-- Style -->
<style>
</style>